import ToDoIcon from "./svgs/to_do.svg";
import InProgress from "./svgs/in_progress.svg";
import CompleteIcon from "./svgs/complete.svg";

const StateMap = {
  to_do: {
    component: ToDoIcon,
    altText: "To Do",
  },
  in_progress: {
    component: InProgress,
    altText: "In Progress",
  },
  complete: {
    component: CompleteIcon,
    altText: "Complete",
  },
};

interface ClickableDotsProps {
  dotState: keyof typeof StateMap;
  size?: number;
  title?: string;
  onClick: () => void;
}

export default function ClickableDot({ dotState, onClick, size = 16, title }: ClickableDotsProps) {
  return (
    <button onClick={onClick} className="cursor-pointer" title={title}>
      <img
        src={StateMap[dotState].component}
        alt={StateMap[dotState].altText}
        width={size}
        height={size}
      />
    </button>
  );
}
